var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paginatedCollection.collection.length == 0 && !_vm.isLoading)?_c('v-row',{staticClass:"mb-5",attrs:{"justify":"center"}},[_vm._v(" لم يتم العثور على نتائج...... ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }